import './index.scss';

export default function SwitchSmall({ value, id, onChange, color, isDisabled=false }) {
  return (
    <label className="switch-small">
      <input
        type="checkbox"
        id={id}
        checked={value ? value : false}
        onChange={(e) => onChange(!value)}
        className={color ? color : ""}
        disabled={isDisabled}
      />
      <span className={ `${color ? color : ''} slider-small round`}></span>
    </label>
  );
}
